/* I13C in DS */
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const ArrowUp: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.16399 9.70968L7.11373 4.75993C7.50426 4.36941 8.13742 4.36941 8.52795 4.75993L13.4777 9.70968C13.8682 10.1002 13.8682 10.7334 13.4777 11.1239C13.0872 11.5144 12.454 11.5144 12.0635 11.1239L7.82009 6.88179L3.5782 11.1239C3.18768 11.5144 2.55451 11.5144 2.16399 11.1239C1.77346 10.7334 1.77346 10.1002 2.16399 9.70968Z"
        />
      </svg>
    </IconWrap>
  );
};
ArrowUp.displayName = 'ArrowUp';

export default ArrowUp;
